<template>
  <div class="flex items-center">
    <Button
      v-if="showHelp"
      class="meta-link"
      href="http://help.promo.ai/category/newsletters-by-promo-ai/"
      target="_blank"
    >
      <v-icon
        slot="icon-start"
        name="question"
        scale=".7"
        class="meta-link-icon mr-1"
      />
      Help
    </Button>
  </div>
</template>

<script>
import { getAccountId } from "@/lib/auth";

export default {
  name: "SupportNav",
  props: {
    location: {
      type: String,
      default: "header",
    },
    showFeedback: {
      type: Boolean,
      default: true,
    },
    showHelp: {
      type: Boolean,
      default: true,
    },
    showUpdates: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.meta-link {
  @apply text-grey-dark font-normal font-sans text-xs p-0 mr-2 no-underline;

  &:hover {
    @apply text-brand-lighter;
  }

  @screen md {
    @apply px-0 text-grey font-light;
  }
}
</style>
